// extracted by mini-css-extract-plugin
export default {"wrapper":"Nav_wrapper__IRRfw","item":"Nav_item__Y2DF7","selected":"Nav_selected__g1IiI","horizontal":"Nav_horizontal__Y7n8l"};